import { ENDPOINT } from '~/constants';

import { type UUID } from '~/types/common';

import { HTTPError, vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

import { zodCompanyAliasAddressSchema } from '../validations';

import { type CompanyAliasAddressResponse } from './types';

/**
 * Fetches a single company alias address by a given aliasAddressId.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company-Alias-Addresses/operation/get_company_address_vadmin_company_alias_address__company_address_uuid__get
 */
export const fetchCompanyAliasAddress = async (aliasAddressId: UUID) => {
  try {
    return await vestigasApi
      .get(ENDPOINT.COMPANY.ALIAS_ADDRESS.GET(aliasAddressId), {
        validate: {
          response: zodCompanyAliasAddressSchema,
        },
      })
      .json<CompanyAliasAddressResponse>();
  } catch (error) {
    log.error({
      message: 'Error fetching company alias address',
      error,
    });

    let errorMessage = '';

    if (error instanceof HTTPError) {
      switch (error.response.status) {
        case 404: {
          errorMessage = i18n.t(
            ($) => $.company.fetchCompanyAliasAddress.error404,
            {
              ns: 'data',
            },
          );
          break;
        }

        default: {
          errorMessage = i18n.t(
            ($) => $.company.fetchCompanyAliasAddress.error.generic,
            { ns: 'data' },
          );
        }
      }
    }

    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
